import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import axios from "axios";
import base_url from "../../api/bootapi";
import { useForm } from "react-hook-form";
import Modal from "react-bootstrap/Modal";
import Cards from "react-credit-cards";
import Select from "react-select";
import PlanModal from "../../Modal/PlanModal";
import { useStateValue } from "../../Registration/Components/ContextAPI/StateProvider";
import PlanModalOBD from "../../Modal/PlanModalOBD";

const ReactivationOBDForm = () => {
  const { search } = useLocation();
  const queryparam = queryString.parse(search);
  // eslint-disable-next-line
  const [{ servicePlanGPS, servicerules, servicePlan }, dispatch] =
    useStateValue();

  //------------------->Boolean States
  const [loader, setloader] = useState(false);
  const [showimeiui, setshowimeiui] = useState(false);
  const [error, seterror] = useState(false);
  const [success, setsuccess] = useState(false);
  const [showsuccessmodal, setshowsuccessmodal] = useState(false);

  //------------------------>Data storing states
  const [customerdata, setcustomerdata] = useState();
  const [imeidevice, setimeidevice] = useState("");
  const [category, setcategory] = useState("gps");
  const [imeidevicedetail, setimeidevicedetail] = useState();
  const [datearray, setdatearray] = useState([]);
  const [montharray, setmontharray] = useState([]);
  // const [obdplan, setobdplan] = useState([]);
  // const [gpsplan, setgpsplan] = useState([]);
  const [devices, setdevices] = useState([]);
  const [newcardnumber, setnewcardnumber] = useState("");
  const [cardyear, setcardyear] = useState("");
  const [cardmonth, setcardmonth] = useState("");
  const [expiry, setexpiry] = useState("");
  const [cardholdername, setcardholdername] = useState("");
  const [cvc, setcvc] = useState("");
  const [focus, setfocus] = useState();
  const [message, setmessage] = useState();
  const [selplan, setselplan] = useState("");
  const [servicePlanerror, setservicePlanerror] = useState(false);
  const [show, setshow] = useState(false);
  const [details, setdetails] = useState({});
  const [plandetail, setplandetail] = useState({});
  //------------------------->Storing position of div ref
  const messagesEndRef = useRef(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });
  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    setloader(true);
    addyears();
    // getservicePlan();
    getcustomerdetails();
  }, []);
  const addyears = () => {
    let date2 = new Date();
    let arr = [date2.getFullYear()];
    for (let i = 1; i <= 16; i++) {
      let date = new Date();
      let adddata = date.getFullYear() + i;
      arr.push(adddata);
    }
    let month = Array.from(Array(12), (val, index) => index + 1);
    month.forEach((item) => {
      let appendedvalue = String(item).padStart(2, "0");
      setmontharray((prev) => [...prev, appendedvalue]);
    });
    setdatearray(arr);
  };
  // const getservicePlan = () => {
  //   axios.get(`${base_url}/info/service_plan/obd`).then((res) => {
  //     setobdplan(res.data.plans);
  //   });
  //   axios.get(`${base_url}/info/service_plan`).then((res) => {
  //     setgpsplan(res.data.plans);
  //   });
  // };
  const getcustomerdetails = () => {
    axios
      .get(`${base_url}/auth/re-activation/devices/${queryparam?.customer_id}`)
      .then((res) => {
        setloader(false);
        let groupedoptions = [];
        if (res.data.status) {
          let options = [];
          let options2 = [];
          for (let i = 0; i < res.data.devices.length; i++) {
            if (res.data.devices[i]["category"] === "gps") {
              let option = {
                id: i + 1,
                label: res.data.devices[i].imei_no,
                value: res.data.devices[i].imei_no,
                category: "gps",
              };
              if (queryparam?.imei === res.data.devices[i].imei_no) {
                setimeidevice(option);
              }
              options.push(option);
            } else {
              let option = {
                id: i + 1,
                value: res.data.devices[i].imei_no,
                label: res.data.devices[i].imei_no,
                category: "obd",
              };
              if (queryparam?.imei === res.data.devices[i].imei_no) {
                setimeidevice(option);
              }
              options2.push(option);
            }
          }
          if (options.length > 0) {
            let groupedoption = {
              label: "GPS",
              options,
            };
            groupedoptions.push(groupedoption);
          }
          if (options2.length > 0) {
            let groupedoption = {
              label: "OBD",
              options: options2,
            };
            groupedoptions.push(groupedoption);
          }
          setdevices(groupedoptions);
        }
        setcustomerdata(res.data);
      })
      .then((res) => {
        setloader(false);
      });
  };
  const handleselectimei = (list, item) => {
    setcategory(list.category);
    setimeidevice(list);
    if (list.category === "gps") {
      setplandetail(servicePlanGPS["plus_quarterly"]);
      setselplan("plus_quarterly");
    } else {
      setplandetail(servicePlan["plus_obd_quarterly"]);
      setselplan("plus_obd_quarterly");
    }
  };
  const checkimeidetails = () => {
    setshowimeiui(true);
    setloader(true);
    seterror(false);
    setsuccess(false);
    axios
      .get(
        `${base_url}/auth/re-activation/device/info/${queryparam?.customer_id}/${imeidevice?.value}`
      )
      .then((res) => {
        setloader(false);
        setimeidevicedetail(res.data);
      })
      .catch((err) => {
        setloader(false);
      });
  };
  const onyearChange = (e) => {
    setmontharray([]);
    if (Number(e.target.value) === Number(new Date().getFullYear())) {
      let monthnumber = new Date().getMonth();
      let month = Array.from(
        Array(12 - monthnumber),
        (val, index) => monthnumber + index + 1
      );
      month.forEach((item) => {
        let appendedvalue = String(item).padStart(2, "0");
        setmontharray((prev) => [...prev, appendedvalue]);
      });
      if (Number(cardmonth) < Number(monthnumber + 1)) {
        setcardmonth("");
      }
    } else {
      let month = Array.from(Array(12), (val, index) => index + 1);
      month.forEach((item) => {
        let appendedvalue = String(item).padStart(2, "0");
        setmontharray((prev) => [...prev, appendedvalue]);
      });
    }
  };

  const changeserviceplan = (e) => {
    let plan = e.target.value;
    if (servicePlan[plan]) {
      setplandetail(servicePlan[plan]);
    } else if (servicePlanGPS[plan]) {
      setplandetail(servicePlanGPS[plan]);
    }
    setselplan(e.target.value);
  };
  const reactivatedevice = (data2) => {
    if (!cardmonth) {
      return;
    }
    if (!selplan) {
      setservicePlanerror(true);
      return;
    }
    setservicePlanerror(false);
    let data = {
      credit_card: {
        cardholder_name: data2.cardholderName,
        cvv: data2.cvc,
        expiration_date: `${cardmonth}/${cardyear}`,
        number: data2.cardNumber,
      },
      customer_id: queryparam?.customer_id,
      imei: imeidevicedetail?.device?.imei_no,
      service_plan: selplan,
    };
    setdetails(data);
    setshow(true);
  };

  const continueresult = () => {
    setshow(false);
    setloader(true);
    axios
      .post(`${base_url}/auth/re-activation/device/reactivate`, details)
      .then((res) => {
        setloader(false);
        if (res.data.status) {
          setsuccess(true);
          seterror(false);
          setshowsuccessmodal(true);
        } else {
          let error = res.data.message;
          if (res.data.error) error = error + " : " + res.data.error;
          setmessage(error);
          setsuccess(false);
          seterror(true);
          setloader(false);
          scrollToBottom();
        }
      })
      .catch((err) => {
        if (err.response) {
          let error = err.response.data?.message;
          if (err.response.data?.error) {
            error = error + " : " + err.response.data?.error;
          }
          setmessage(error);
        } else {
          setmessage("Something Went Wrong");
        }
        setsuccess(false);
        seterror(true);
        setloader(false);
        scrollToBottom();
      });
  };
  const handleCloseModal = () => {
    setshowsuccessmodal(false);
    setsuccess(true);
    scrollToBottom();
  };
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <form id="myForm" onSubmit={handleSubmit(reactivatedevice)}>
      <div>
        <h4 className="cancellationobd_h4">
          Reactivate GPS Subscription Request
        </h4>
        {loader ? (
          <img width={300} alt="loader" src="./loading.gif" />
        ) : (
          <>
            {!showimeiui ? (
              <>
                <div className="form-group">
                  <div className="row text-left form-group">
                    <div className="col-md-3 reactivationobd_font">
                      Customer ID :
                    </div>
                    <div className="col-md-9 reactivationobd_font">
                      {queryparam?.customer_id}
                    </div>
                  </div>
                  <div className="row text-left ">
                    <div className="col-md-3 reactivationobd_font">Name :</div>
                    <div className="col-md-9 reactivationobd_font">
                      {customerdata?.user_details?.first_name}{" "}
                      {customerdata?.user_details?.last_name}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <Select
                        value={imeidevice}
                        options={devices}
                        onChange={handleselectimei}
                      />
                      {/* <select
                        value={imeidevice}
                        onChange={(e) => setimeidevice(e.target.value)}
                        className="form-control"
                      >
                        <option value="">Select IMEI</option>
                        {customerdata?.devices?.map((item, index) => (
                          <option key={index + 1} value={item.imei_no}>
                            {item.imei_no}
                          </option>
                        ))}
                      </select> */}
                    </div>
                    <div className="col-md-6">
                      <button
                        disabled={!imeidevice?.value}
                        className={
                          !imeidevice?.value
                            ? "btn btn-primary buttondisabled reactivatebutton"
                            : "btn btn-primary reactivatebutton"
                        }
                        onClick={checkimeidetails}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="form-group">
                  <div className="row text-left form-group">
                    <div className="col-md-5 reactivationobd_font">
                      Customer ID :
                    </div>
                    <div className="col-md-7 reactivationobd_font">
                      {queryparam?.customer_id}
                    </div>
                  </div>
                  <div className="row text-left ">
                    <div className="col-md-5 reactivationobd_font">Name :</div>
                    <div className="col-md-7 reactivationobd_font">
                      {imeidevicedetail?.user_details?.first_name}{" "}
                      {imeidevicedetail?.user_details?.last_name}
                    </div>
                  </div>
                  <div className="row text-left ">
                    <div className="col-md-5 reactivationobd_font">
                      IMEI NUMBER :
                    </div>
                    <div className="col-md-7 reactivationobd_font">
                      {imeidevicedetail?.device?.imei_no}
                    </div>
                  </div>
                  <div className="row text-left ">
                    <div className="col-md-5 reactivationobd_font">ICCID :</div>
                    <div className="col-md-7 reactivationobd_font">
                      {imeidevicedetail?.device?.imei_iccid}
                    </div>
                  </div>
                  <div className="row text-left ">
                    <div className="col-md-5 reactivationobd_font">
                      Previous Activated Plan :
                    </div>
                    <div className="col-md-7 reactivationobd_font">
                      {imeidevicedetail?.device?.activated_plan_description}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      {/* <select
                        {...register("servicePlan", { required: true })}
                        className="form-control"
                      >
                        <option value="">SELECT PLAN</option>
                        {gpsplan?.map((item) => (
                          <option key={item.id} value={item.service_plan_id}>
                            {item.service_plan_name}
                          </option>
                        ))}
                      </select> */}
                      {category === "gps" ? (
                        <PlanModal
                          servicerules={servicerules}
                          servicePlanGPS={servicePlanGPS}
                          plan={selplan}
                          handledeviceplanchange={changeserviceplan}
                          index={0}
                        />
                      ) : (
                        <PlanModalOBD
                          servicerules={servicerules}
                          servicePlanGPS={servicePlan}
                          plan={selplan}
                          handledeviceplanchange={changeserviceplan}
                          index={0}
                        />
                      )}
                      {/* <select
                          value={selplan}
                          className="form-control"
                          onChange={(e) => changeserviceplan(e)}
                        >
                          <option value="">SELECT PLAN</option>
                          {servicePlan?.map((item) => (
                            <option key={item.id} value={item.service_plan_id}>
                              {item.service_plan_name}
                            </option>
                          ))}
                        </select> */}
                      {servicePlanerror && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          Service Plan is required
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <Cards
                    number={newcardnumber}
                    name={cardholdername}
                    expiry={expiry}
                    cvc={cvc}
                    focused={focus}
                  />
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      <input
                        {...register("cardholderName", { required: true })}
                        className="form-control"
                        placeholder="Card Holder Name"
                        onChange={(e) => setcardholdername(e.target.value)}
                        onFocus={(e) => setfocus(e.target.name)}
                      />
                      {errors.cardholderName && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          Card Holder Name is required
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-9">
                      <input
                        {...register("cardNumber", {
                          required: true,
                          maxLength: 20,
                          minLength: 15,
                        })}
                        type="number"
                        onWheel={(event) => event.currentTarget.blur()}
                        className="form-control"
                        placeholder="Card Number"
                        onChange={(e) => setnewcardnumber(e.target.value)}
                        onFocus={(e) => setfocus(e.target.name)}
                      />
                      {errors.cardNumber?.type === "required" && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CardNumber is required
                        </span>
                      )}
                      {errors.cardNumber?.type === "minLength" && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CardNumber should be minimum of 15 numbers
                        </span>
                      )}
                      {errors.cardNumber?.type === "maxLength" && (
                        <span
                          className="errormessage"
                          style={{ fontSize: "15px" }}
                        >
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CardNumber cannot exceed more than 20 numbers
                        </span>
                      )}
                    </div>
                    <div className="col-md-3">
                      <input
                        {...register("cvc", {
                          required: true,
                          minLength: 3,
                          maxLength: 4,
                        })}
                        type="number"
                        onWheel={(event) => event.currentTarget.blur()}
                        className="form-control"
                        placeholder="CVV"
                        onChange={(e) => setcvc(e.target.value)}
                        onFocus={(e) => setfocus(e.target.name)}
                      />
                      {errors.cvc?.type === "required" && (
                        <span
                          className="errormessage text-left"
                          style={{ fontSize: "14px" }}
                        >
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CVV is required
                        </span>
                      )}
                      {errors.cvc?.type === "minLength" && (
                        <span
                          className="errormessage"
                          style={{ fontSize: "14px" }}
                        >
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CVV should be minimum of 3 numbers
                        </span>
                      )}
                      {errors.cvc?.type === "maxLength" && (
                        <span
                          className="errormessage"
                          style={{ fontSize: "14px" }}
                        >
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CVV cannot be more than 4 numbers
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-6">
                      <select
                        {...register("expirationdatemonth", { required: true })}
                        value={cardmonth}
                        onChange={(e) => {
                          setcardmonth(e.target.value);
                          setexpiry(`${e.target.value}/${cardyear}`);
                        }}
                        onFocus={(e) => setfocus(e.target.value)}
                        className="form-control"
                      >
                        <option value="">MM</option>
                        {montharray?.map((item, index) => (
                          <option key={index + 1} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                      {errors.expirationdatemonth && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          Month is required
                        </span>
                      )}
                    </div>
                    <div className="col-md-6">
                      <select
                        {...register("expirationdateyear", { required: true })}
                        value={cardyear}
                        onChange={(e) => {
                          setcardyear(e.target.value);
                          onyearChange(e);
                          setexpiry(`${cardmonth}/${e.target.value}`);
                        }}
                        className="form-control"
                        onFocus={(e) => setfocus(e.target.value)}
                      >
                        <option value="">YYYY</option>
                        {datearray?.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                      {errors.expirationdateyear && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          Year is required
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {error ? (
                  <div>
                    <div className="alert alert-danger">
                      <strong>Error! </strong>
                      {message}
                    </div>
                  </div>
                ) : null}
                <div ref={messagesEndRef} />
                {success ? (
                  <div>
                    <div className="alert alert-success">
                      <strong>Success! </strong>
                      Reactivated Device Successfully, Happy tracking
                    </div>
                  </div>
                ) : (
                  <div
                    className="activation"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div></div>
                    <button className={"btn btn-primary"} type="submit">
                      Update
                    </button>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
      <Modal size="lg" backdrop="static" show={show}>
        <Modal.Header>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          You are choosing:
          <p>
            {1}. <strong>{plandetail["service_plan_name"]}</strong> plan - so
            you will be charged <strong>USD {plandetail["price"]}</strong>.
          </p>
          <p>
            Total Billed: <strong>USD {plandetail["price"]}</strong> instantly.
          </p>
          Are you sure want to continue?
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-success" onClick={continueresult}>
            Confirm
          </button>
          <button className="btn btn-danger" onClick={() => setshow(false)}>
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        size="md"
        show={showsuccessmodal}
        onHide={() => handleCloseModal()}
        backdrop="static"
      >
        <Modal.Header closeButton={() => handleCloseModal()}>
          <Modal.Title style={{ color: "#3947e6" }}>Success!!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className="form-main" style={{ color: "#3947e6" }}>
            Reactivated Device Successfully, Happy tracking
          </h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => handleCloseModal()}
            type="button"
            className="btn btn-primary"
          >
            Ok
          </button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default ReactivationOBDForm;
